import React from 'react';
import { processSteps, processImage } from '../../lib/data';
import { Eyebrow, Reveal } from '../ui/Reveal';
export function Process() {
  return <section className="bg-ink text-ivory-200" data-id="element-97" data-mp="2bkea0mzg7mjd">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-20 lg:grid-cols-12 lg:gap-16 lg:px-10 lg:py-28" data-id="element-98" data-mp="2gh4zu2121whz">
        <div className="lg:col-span-5" data-id="element-99" data-mp="2lhiwyp14bm18">
          <Reveal data-id="element-100" data-mp="2leenbc4vvy36">
            <Eyebrow className="text-gold" data-id="element-101" data-mp="2qfkfn8umtjc6">Our approach</Eyebrow>
            <h2 className="mt-6 font-serif text-3xl leading-tight text-ivory-100 sm:text-4xl" data-id="element-102" data-mp="2qfc3jj6c2i21">
              A method refined over four decades.
            </h2>
            <p className="mt-4 text-lg leading-relaxed text-ink-400" data-id="element-103" data-mp="2z7mfb4wvmvle">
              Every search is partner-led and bespoke — a disciplined process that
              consistently delivers extraordinary leaders.
            </p>
          </Reveal>
          <Reveal delay={0.15} data-id="element-104" data-mp="393z71x8v2zdi">
            <div className="mt-8 overflow-hidden rounded-2xl" data-id="element-105" data-mp="3e4wx0w044xpk">
              <img src={processImage} alt="A recruiter meeting with a candidate" className="h-64 w-full object-cover lg:h-72" data-id="element-106" data-mp="3e32chisr77m0" />
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7 lg:pt-4" data-id="element-107" data-mp="2uah736omoc2u">
          <ol className="relative" data-id="element-108" data-mp="2ubaiikyj7prb">
            {processSteps.map((step, i) => <Reveal key={step.number} delay={i * 0.1} data-id="element-109" data-mp="2qaqjfbueec2j" data-mpi={i}>
                <li className="relative flex gap-6 pb-10 last:pb-0" data-id="element-110" data-mp="3mzeol7l0m4uj">
                  {i < processSteps.length - 1 && <span className="absolute left-[27px] top-14 h-[calc(100%-2rem)] w-px bg-ink-700" data-id="element-111" data-mp="3i1mmjkqnp2cm" />}
                  <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full border border-gold/40 font-serif text-lg text-gold" data-id="element-112" data-mp="3d8bqmendu5zh">
                    {step.number}
                  </span>
                  <div className="pt-2" data-id="element-113" data-mp="9m2yd04uea4f">
                    <h3 className="font-serif text-xl text-ivory-100" data-id="element-114" data-mp="4tjk00ybzayk">{step.title}</h3>
                    <p className="mt-2 max-w-lg text-sm leading-relaxed text-ink-400" data-id="element-115" data-mp="1z1x88s4825ey">
                      {step.description}
                    </p>
                  </div>
                </li>
              </Reveal>)}
          </ol>
        </div>
      </div>
    </section>;
}